import { useQuery } from 'react-query'

import { restrictedWordsService } from '@/modules/restricted-words/service/restricted-words-service.ts'
import { handleError } from '@/utils/error'

export function useRestrictedWords() {
  const { data, isLoading, refetch } = useQuery(
    'restrictedWords',
    () => restrictedWordsService.getRestrictedWords(),
    {
      onError: (error) =>
        handleError(error, 'Failed to get restricted words', refetch),
    },
  )

  return {
    restrictedWords: data,
    isRestrictedWordsLoading: isLoading,
  }
}
